var THF = THF || {};
THF.Interface = THF.Interface || {};

(function ($, jQuery) {
    'use strict';

    THF.Interface.HealthHubCategoryPageTracking = function (options) {

        var defaults = {

            selectors: {
                parentElem: '.health-hub-category',
                categoryCTAs: '.categories-ctas',
                categoryTiles: '.category-tile',
                serviceTile: '.hh-service-tile'
            }
        };

        options = $.extend(true, {}, defaults, options);


        /**********************************
         // Declare DOM elements
         **********************************/
        var parentElem = $(options.selectors.parentElem);
        var categoryCTAs = $parentElem(options.selectors.categoryCTAs);
        var categoryTiles = categoryCTAs.find(options.selectors.categoryTiles);
        var serviceTile = categoryCTAs.find(options.selectors.serviceTile);



        /**********************************
         // Helper function to return a jQuery object, which is a child of 'parentElem'
         **********************************/
        function $parentElem(selector) {
            return $(options.selectors.parentElem + ' ' + selector);
        }


        /**********************************
         // Event binding
         **********************************/
        function bindEvents() {

            /* Category Page: Article Tiles in the 'Browser more articles' */
            categoryTiles.each(function () {
                var categoryTile = $(this);
                var categoryTileButton = categoryTile.find('a');

                categoryTileButton.click(function (e) {
                    //e.preventDefault();
                    //console.log('Category Page >> Browse More Articles >> Category Tile Clicked.');
                    //console.log($(this).attr('href'));
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'categoryBrowseMoreCard',
                        'type': 'Category',
                        'pagePath': $(this).attr('href')
                    });
                });
            });

            /* Category Page: Single Service Tile in the 'Browse more articles as last item' */
            var serviceTileButton = serviceTile.find('a');
            serviceTileButton.click(function (e) {
                //e.preventDefault();
                //console.log('Category Page >> Browser More Articles >> Service Tile or Contact Us Clicked.');
                //console.log($(this).attr('href'));
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'categoryBrowseMoreCard',
                    'type': 'Contact',
                    'pagePath': $(this).attr('href')
                });
            });
        }

        /**********************************
         // Simple constructor
         **********************************/
        function __construct() {

            // Init
            if (parentElem.length > 0) {
                bindEvents();
            }
        }

        __construct();


        //
        // Make some events accessible from global scope
        //
        return {

        };
    };
})(jQuery, jQuery)